import { render, staticRenderFns } from "./MarkingAnswerPaper.vue?vue&type=template&id=e6bdc040"
import script from "./MarkingAnswerPaper.vue?vue&type=script&lang=js"
export * from "./MarkingAnswerPaper.vue?vue&type=script&lang=js"
import style0 from "./MarkingAnswerPaper.vue?vue&type=style&index=0&id=e6bdc040&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports